import {createShopifyImageUrl} from '@/utilities/create-shopify-image-url';
import {preloadImage} from '@/utilities/preload-image';
import {safeParseOrElse} from '@/utilities/safe-parse-or-else';
import register from 'preact-custom-element';
import {useEffect, useMemo} from 'preact/hooks';
import {z} from 'zod';
import TrialImageCarousel from './TrialImageCarousel';

function Loader({
  imageUrls: imageUrlsJson,
  aspectRatio,
  activeSlide,
}: {
  imageUrls: string;
  aspectRatio?: string;
  activeSlide?: string;
}) {
  const imageUrls = useMemo(
    () =>
      safeParseOrElse(z.array(z.string()), [], JSON.parse(imageUrlsJson)).map(
        (url) => createShopifyImageUrl(url, 640)
      ),
    [imageUrlsJson]
  );
  useEffect(() => imageUrls.forEach(preloadImage), [imageUrls]);

  return <TrialImageCarousel imageUrls={imageUrls} aspectRatio={aspectRatio} activeSlide={activeSlide != null ? Number(activeSlide) : undefined} />;
}
register(Loader, 'image-carousel', ['imageUrls', 'aspectRatio', 'activeSlide']);
